import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly apiPrefixes = [
    environment.API_DOMAINS.OTIC_CR,
    environment.API_DOMAINS.USUARIOS,
    environment.API_DOMAINS.COMUNES,
  ].map((url) => this.normalizeUrl(url));

  constructor(private readonly authService: AuthenticationService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.shouldAttachToken(req.url) || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const token = this.getToken();
    if (!token) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }

  private getToken(): string {
    return (
      this.authService.getToken() ||
      this.authService.currentUserValue?.token ||
      ''
    );
  }

  private shouldAttachToken(url: string): boolean {
    if (!url || url.startsWith('/assets')) {
      return false;
    }

    if (url.includes(environment.sso.url)) {
      return false;
    }

    const normalizedUrl = this.normalizeUrl(url);
    return this.apiPrefixes.some((prefix) => normalizedUrl.startsWith(prefix));
  }

  private normalizeUrl(url: string): string {
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }
}
